<div id="global-spinner-fade"
     [style.display]="divDisplay"></div>
<div id="global-spinner-modal"
     [style.display]="divDisplay"
     [style.left]="spinnerModalLeftEdge + 'px'"
     [style.top]="spinnerModalTopEdge + 'px'">
    <div>
        <img id="loader" src="/Cache/images/icon_load.gif" />
    </div>
    <div><label><strong>{{currentMsg}}</strong></label></div>
    <div *ngIf="showProgress">{{progressCurrent}} / {{progressTotal}}</div>
    <div class="progress" *ngIf="showProgress">
        <div class="progress-bar" role="progressbar" attr.aria-valuenow="{{progressCurrent}}" attr.aria-valuemin="0" attr.aria-valuemax="{{progressTotal}}" [style.width]="percentComplete +'%'">
        </div>
    </div>
    <button type="button" class="btn btn-primary" *ngIf="showCloseButton" (click)="hideSpinner(null, true)">Close</button>
</div>